var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeslash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9621 5.32626C11.321 5.17235 10.6658 5.08057 10.0001 5.08057C7.02634 5.08057 4.2143 6.67686 2.36243 9.3364C1.87952 10.0297 1.87952 10.9708 2.36243 11.6641C2.81428 12.3129 3.32472 12.8954 3.87894 13.4101L11.9621 5.32626Z",
    fill: "#6C7C83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6383 9.33638C16.897 8.27171 15.9969 7.38708 14.9979 6.70084L16.8116 4.88709C17.1427 4.55597 17.1427 4.01941 16.8116 3.68899C16.4805 3.35858 15.9439 3.35787 15.6135 3.68899L3.1884 16.1127C2.85728 16.4438 2.85728 16.9804 3.1884 17.3108C3.35361 17.476 3.57106 17.5593 3.78781 17.5593C4.00455 17.5593 4.2213 17.4767 4.38721 17.3108L6.53631 15.1617C7.62992 15.6495 8.79978 15.9192 10 15.9192C12.9744 15.9192 15.7865 14.3229 17.6383 11.6634C18.1205 10.9708 18.1205 10.0297 17.6383 9.33638ZM9.99929 13.3056C9.53403 13.3056 9.09983 13.1848 8.71506 12.9822L12.4816 9.21565C12.6843 9.60042 12.805 10.0339 12.805 10.4992C12.805 12.0475 11.5462 13.3056 9.99929 13.3056Z",
    fill: "#6C7C83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeslash);
export default __webpack_public_path__ + "static/media/eyeslash.dd3ba9a221d6859ef759627d47ee7a5e.svg";
export { ForwardRef as ReactComponent };